// Tooltip

'use strict';

$ice('[data-bs-toggle*="tooltip"]', e => new Tooltip(e));
